import ApiRequestManagerInstance from '../ApiRequestManager';
import TranslationManager from '../../assets/locale/translationsManager';
import { store } from '../../store/store';
import { IRailsRequest } from '../../types/interfaces/rail';
import Rail from '../../classes/rail';

function contentRequest(id: string) {
  const promise = new Promise<Rail[]>(async (resolve) => {
    try {
      const { user } = store.getState();
      const response: IRailsRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'apiUrl',
          section: `media${user.isAnonymous ? 'free' : ''}`,
          subsection: 'corner',
          type: 'content',
          params: id + '?lang=' + TranslationManager.currentLanguage,
        },
      })) as unknown as IRailsRequest;
      let rails: Rail[] = [];
      if (response?.data?.length) {
        rails = response.data?.map((item) => new Rail(item));
      }
      resolve(rails);
    } catch (e) {
      resolve([]);
    }
  });

  return promise;
}

export default contentRequest;
